<template>
    <section class="quick-accordion">
        <b-card no-body>
            <b-card-header>
                <div class="flex-title-buttons" v-b-toggle="(id + '-id')">
                    <span class="flex-title" v-if="title">{{ title }}</span>
                    <b-button variant="white">
                        <b-icon-chevron-down></b-icon-chevron-down>
                    </b-button>
                </div>
            </b-card-header>
            <b-collapse :id="(id + '-id')" class="mt-2" :visible="visible">
                <slot></slot>
            </b-collapse>
        </b-card>
    </section>
</template>
<script>
import { BIconChevronDown } from 'bootstrap-vue';

export default {
    components: {
        BIconChevronDown,
    },
    props: {
        id: {
            required: true,
        },
        title: {
            required: false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getClasses(icon, color) {
            return [`icon-${icon}`, `text-${color}`, 'ml-10'].join(' ');
        },
    },
};
</script>
<style scoped>
.flex-title {
    font-size: 16px;
    font-weight: 500;
}

.flex-title-buttons {
    display: grid;
    justify-content: space-between;
    align-items: center;
    grid-template-columns: 1fr 80px;
    width: 100%;
    line-height: 1;
    padding-left: 0.5rem;
}

.flex-combo-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.not-collapsed .bi-chevron-down {
    transform: rotate(180deg);
}

.quick-accordion .card-header {
    padding: 0.25rem;
    border-bottom: 1px solid #dfdfdfad;
}
</style>
